import { render, staticRenderFns } from "./DialogEditClient.vue?vue&type=template&id=b5f1500c&scoped=true"
import script from "./DialogEditClient.vue?vue&type=script&lang=js"
export * from "./DialogEditClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f1500c",
  null
  
)

export default component.exports